import React, { useState, useEffect, useContext } from "react";
import "../styles/filing.css";
import { Link, useNavigate, useParams } from "react-router-dom";
import DynamicIcon from "../components/dynamicicon";
import Case_Search from "../components/core/case_search";
import { Search } from "@mui/icons-material";
import JisInput from "../components/controls/jisInput";
import JisInputView from "../components/controls/jisinputView";
import JisCheckbox from "../components/controls/jisCheckbox";
import JisButton from "../components/controls/jisButton";
import JisDropdown from "../components/controls/jisDropdown";
import FlowItem from "../components/controls/flowitem";
import { ShareContext } from "../context/ShareContext";

import * as Constants from "../constants";
import JisDialog from "../components/dialog";
import Gazette from "../components/core/gazette";
import BackLoader from "../components/backloader";
import Payment from "../components/core/payment";
import JisYesNo from "../components/controls/jisYesNo";
import JisParty from "../components/controls/jisparty";
import PdfViewer from "../components/controls/pdfviewer";
import MultiSelectDropdown from "../components/controls/multiselectdropdown";
import CaseHeader from "../components/core/CaseHeader";
import JisPrompt from "../components/jisprompt";
import { div } from "framer-motion/client";
import JisDialogForm from "../components/formdialog";

function Filing_Case() {
  const navigate = useNavigate();
  const { caseid } = useParams();
  const FeeTYPEID = 1;
  const { activePage, token, profile, setIsExpired, setAlert, frequentData } =
    useContext(ShareContext);
  const [cinfo, setCase] = useState({
    stateId: Constants.Default_State,
    processType: "Normal",
    isPublic: 1,
    caseFilingId: 1,
    isDelarative: true,
    isRequireInterpretation: true,
    isLegalPolicy: true,
    isLegalPosition: true,
    isEmergency: true,
    isDispute: true,
    isUniform: true,
  });

  const [flow, setFlow] = useState({ pos: 1, code: "case_details" });
  const [flowerror, setFlowError] = useState("");
  const [isSuccess, setIsSuccess] = useState(false);
  const [casetypes, setCasetypes] = useState([]);
  const [caseorigins, setCaseorigins] = useState([]);
  const [casecategories, setCasecategories] = useState([]);
  const [divisions, setDivisions] = useState([]);
  const [partytypes, setPartytypes] = useState([]);
  const [motiontypes, setMotiontypes] = useState([]);
  const [motionclass, setMotionclass] = useState([]);
  const [causeOfActions, setCauseOfActions] = useState([]);
  const [isVacation, setIsVacation] = useState(false);
  const [previewPrayer, setPreviewPrayer] = useState(null);
  const [selectedCauses, setSelectedCauses] = useState([]);
  const [otherCauses, setOtherCauses] = useState([]);
  const [removingIndex, setRemovingIndex] = useState(null);
  const [casefees, setCaseFees] = useState([]); //this is the amount created to be sent to Pay4It
  const [isFiat, setIsFiat] = useState(false);
  const [fiat, setFiat] = useState(null);
  const [fiatUrl, setFiatUrl] = useState("");
  const [isPreview, setIsPreview] = useState(false);

  const [states, setStates] = useState([]);
  const [Lga, setLga] = useState([]);
  const [cities, setCities] = useState([]);

  const [loading, setLoading] = useState(false);
  const [legal, setLegal] = useState({});
  const [showLegals, setShowLegals] = useState(false);
  const [claims, setClaims] = useState([
    { claim: "", claimValue: "", currencyType: "" },
  ]);
  const [parties, setParties] = useState([]);
  const [party, setParty] = useState({
    isOrg: 0,
    isLeadParty: true,
    state: Constants.Default_State,
    partyTypeId: "",
  });
  const [motions, setMotions] = useState([]);
  const [motion, setMotion] = useState([]);
  const [motionPrayers, setPrayers] = useState([{ prayer: "" }]);
  const [partyOptions, setPartyOptions] = useState([]);
  //const [isNew]

  const [locs, setLocs] = useState({ state: null, lga: null, city: null });
  const [locs2, setLocs2] = useState({ state: null, lga: null, city: null });
  const [isMotion, setIsMotion] = useState(false);
  const [isNewFiat, setNewFiat] = useState(true);
  const [casefeeId, setcasefeeId] = useState(null);
  const [showMotionDialog, setShowMotionDialog] = useState(false);
  const [savedFormState, setSavedFormState] = useState(null);
  const [oldMotionState, setOldMotionState] = useState(null);

  const onSaveToLocal = () => {
    var all = {
      cinfo,
      selectedCauses,
      otherCauses,
      fiat,
      claims,
      parties,
      isFiat,
      fiatUrl,
      isMotion,
      motions,
      userid: profile.id,
    };
    var str = JSON.stringify(all);
    localStorage.setItem("caseinfo", str);
  };

  const onDeleteFromLocal = () => {
    localStorage.removeItem("caseinfo");
  };

  const processmode = [
    { label: "Normal", value: "Normal" },
    { label: "Fast Track", value: "Fast Track" },
    { label: "Urgency", value: "Urgency" },
  ];

  const partydes = [
    { label: "Individual", value: 0 },
    { label: "Organization", value: 1 },
  ];

  const idModes = [
    { label: "Passport", value: "Passport" },
    { label: "National ID", value: "National ID" },
    { label: "Driving Licence", value: "Driving Licence" },
    { label: "Others", value: "Others" },
  ];

  const caseidentity = [
    { label: "Public", value: 1 },
    { label: "Private", value: 0 },
  ];
  const currencies = [
    { label: "Naira (N)", value: "Naira" },
    { label: "Dollar ($)", value: "Dollar" },
    { label: "Euro (e)", value: "Euro" },
  ];

  const onGotoDetails = () => {
    setIsSuccess(false);
    navigate(`/document-upload/${casefeeId}`); //navigate to login
  };
  const on_case_details = (e) => {
    e.preventDefault();
    onSaveToLocal();
    if (isFiat && fiat == null) {
      setFlowError("Please select the FIAT document for upload.");
      return;
    }
    if (!(selectedCauses.length > 0 || otherCauses.length > 0)) {
      setFlowError("Please select one of the causes or enter other causes");
      return;
    }
    setFlowError("");
    //setFlow({pos:2,code:"options"});
    setFlow({ pos: 5, code: "parties" });
  };

  const on_claims = async (e) => {
    e.preventDefault();

    const v = await onSave();

    // If user chose not to file motion, skip to gazette
    if (!isMotion) {
      setFlow({ pos: 8, code: "gazette" });
    } else {
      setFlow({ pos: 7, code: "motions" });
    }
  };
  const on_claims_back = () => setFlow({ pos: 5, code: "parties" });

  const on_parties = async () => {
    // Existing validation: Check if at least one party exists
    if (parties.length == 0) {
      setFlowError("Please save the party before you proceed.");
      return;
    }

    // Existing validation: Check if lead party is selected
    const hasLead = parties.find((r) => r.isLeadParty);
    console.log(hasLead);
    if (!hasLead) {
      setFlowError(
        "Please indicate the lead party, by checking the Lead option",
      );
      return;
    }

    // NEW VALIDATION: Check if at least one defendant/respondent has been added
    // Define all possible opposing party type IDs based on judicial system
    // Common IDs: 1=Petitioner/Claimant/Applicant, 2=Respondent, 4=Defendant, etc.
    const claimantPartyTypeIds = [1, 3, 5, 7]; // Petitioner, Claimant, Applicant, Prosecutor

    // Check for any opposing party (anyone who is NOT a claimant-type party)
    const hasOpposingParty = parties.find((party) => {
      // If party is not a claimant-type, they're an opposing party
      const isClaimantType = claimantPartyTypeIds.includes(party.partyTypeId);

      if (!isClaimantType) {
        // Double-check with party type title
        const partyType = frequentData?.partyTypes?.find(
          (pt) => pt.id == party.partyTypeId,
        );

        if (partyType) {
          const partyTypeTitle = partyType.title?.toLowerCase() || "";
          console.log(
            "Found potential opposing party:",
            partyTypeTitle,
            "with ID:",
            party.partyTypeId,
          );

          // Confirm it's truly an opposing party (not witness, lawyer, etc.)
          const isOpposingParty =
            partyTypeTitle.includes("defendant") ||
            partyTypeTitle.includes("respondent") ||
            partyTypeTitle.includes("accused") ||
            partyTypeTitle.includes("suspect");

          return isOpposingParty;
        }

        // If no party type found in frequentData, assume non-claimant ID is opposing party
        return true;
      }

      return false;
    });

    console.log("Has opposing party:", hasOpposingParty);
    console.log("All parties:", parties);
    console.log("Frequent data party types:", frequentData?.partyTypes);

    if (!hasOpposingParty) {
      setFlowError(
        "You must add at least one defendant/respondent party before proceeding. The case will remain in draft until a defendant/respondent is added.",
      );
      return;
    }

    setLoading(false);
    setFlowError("");
    //const v=await onSave();
    onSaveToLocal();
    setFlow({ pos: 6, code: "claims" });
  };

  const on_parties_back = () => setFlow({ pos: 1, code: "case_details" });
  const on_motions = async () => {
    if (!isMotion) {
      await onSave();
      setFlow({ pos: 8, code: "gazette" });
      return;
    }

    if (isMotion && motions.length == 0) {
      setFlowError("Please save the motion before continuing.");
      return;
    }
    if (cinfo.processType == "Vacation") {
      //check if motion with order 49 exist
      var order49 = motions.find((d) => (d.motionTypeId == 10 || d.motionTypeId == 24));
      if (order49 == null) {
        setFlowError("for Vacation Type you must file Order 49");
        return;
      }
    }
    await onSave();
    //save motion on server
    setFlow({ pos: 8, code: "gazette" });
  };
  const on_motions_back = () => setFlow({ pos: 6, code: "claims" });

  const on_gazette = () => {
    setFlow({ pos: 9, code: "payment" });
  };
  const on_gazette_back = () => {
    if (isMotion) {
      setFlow({ pos: 7, code: "motions" });
    } else {
      setFlow({ pos: 6, code: "claims" });
    }
  };
  const on_payment = () => {
    //the final phase to external payment
  };
  const on_payment_back = () => setFlow({ pos: 8, code: "gazette" });

  const generalBackFn = () => {
    if (flow.code === "case_details") {
      navigate(-1);
    }
    if (flow.code === "parties") {
      on_parties_back();
    }
    if (flow.code === "claims") {
      on_claims_back();
    }
    if (flow.code === "motions") {
      on_motions_back();
    }
    if (flow.code === "gazette") {
      on_gazette_back();
    }
    if (flow.code === "payment") {
      on_gazette_back();
    }
  };

  const handleMotionDialogResponse = (response) => {
    setIsMotion(response);
    setShowMotionDialog(false);
  };

  useEffect(() => {
    var cc = localStorage.getItem("caseinfo");
    if (cc != null) {
      var all = JSON.parse(cc);
      //{cinfo,selectedCauses,otherCauses,fiat,claims,isFiat,fiatUrl,isMotion,motions}
      setCase(all.cinfo);
      setSelectedCauses(all.selectedCauses || []);
      setOtherCauses(all.otherCauses || []);
      setFiat(all.fiat);
      setClaims(
        all.claims || [{ claim: "", claimValue: "", currencyType: "" }],
      );
      setParties(all.parties || []);
      setIsFiat(all.isFiat || false);
      setFiatUrl(all.fiatUrl || "");
      setIsMotion(all.isMotion || false);
      setMotions(all.motions || []);
    }
    onLoad();
    if (caseid) {
      onLoadCase(caseid);
    } else {
      // Show motion dialog only for new case filing (no caseid)
      setShowMotionDialog(true);
    }
    onGetStates();
  }, []);
  useEffect(() => {
    setLegal({
      id: profile?.id,
      name: `${profile?.firstName} ${profile?.lastName ?? ""}`,
    });
  }, [profile]);

  useEffect(() => {
    console.log(`changes in processType ${cinfo.processType}`)
    if(cinfo.processType=="Vacation"){
        if(isMotion!=true){
          setOldMotionState(isMotion);
          setIsMotion(true);
          console.log(`set isMotion to true`);
        }
    }else{
        if(oldMotionState!=null){
          setIsMotion(oldMotionState)
          setOldMotionState(null)
        }
    }
    //setIsMotion(response);
    //setOldMotionState(response);
  }, [cinfo.processType]);

  useEffect(() => {
    // Only clear causes if not restoring from localStorage and caseCategoryId actually changed
    const cc = localStorage.getItem("caseinfo");
    if (!cc && cinfo.caseCategoryId) {
      setSelectedCauses([]);
    }
  }, [cinfo.caseCategoryId]);

  useEffect(() => {
    if (cinfo?.referenceNumber == null) {
      onSaveToLocal();
    }
  }, [parties]);

  useEffect(() => {
    if (cinfo.stateId) {
      onGetLgs(cinfo.stateId);
    }
  }, [cinfo.stateId]);

  useEffect(() => {
    if (cinfo.LocalGovtAreaId) {
      onGetCities(cinfo.LocalGovtAreaId);
    }
  }, [cinfo.LocalGovtAreaId]);

  const onGetStates = async () => {
    //for account registration
    try {
      setLocs({ ...locs, state: false });
      const resp = await fetch(`${Constants.apiUrl}/profile/states`, {
        method: "GET",
        headers: { "Content-Type": "application/json", Authorization: "" },
      });
      const data = await resp.json();
      setLocs({ ...locs, state: true });
      setStates(data);
    } catch (error) {
      setLocs({ ...locs, lga: null });
      console.error(error);
    }
  };

  useEffect(() => {
    if (cinfo.caseCategoryId) {
      onGetCauseOfAction(cinfo.caseCategoryId);
    }
  }, [cinfo.caseCategoryId]);

  useEffect(() => {
    console.log("the use state fiat");
    console.log(fiat);
  }, [fiat]);

  const onGetCauseOfAction = async (id) => {
    //for account registration
    try {
      const resp = await fetch(
        `${Constants.apiUrl}/filing/caause-of-action-by-cat/${id}`,
        {
          method: "GET",
          headers: { "Content-Type": "application/json", Authorization: "" },
        },
      );
      const data = await resp.json();

      setCauseOfActions(data);
    } catch (error) {
      setLocs({ ...locs, lga: null });
      console.error(error);
    }
  };

  const onLoad = async () => {
    //for account registration
    try {
      setLoading(true);
      const resp = await fetch(`${Constants.apiUrl}/filing/new-case-dropdown`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      const data = await resp.json();
      setLoading(false);
      // setCasetypes(data.casetype);
      // setCaseorigins(data.caseorigin);
      // setCasecategories(data.casecategories)
      // setDivisions(data.divisions)
      // setPartytypes(data.partyTypes);
      // setMotionclass(data.motionclass);
      // setMotiontypes(data.motiontypes);
      setIsVacation(data.isVacation);
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  const onLoadCase = async (cid) => {
    //for account registration
    try {
      setLoading(true);
      const resp = await fetch(
        `${Constants.apiUrl}/filing/case-filing/${cid}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const data = await resp.json();
      setLoading(false);
      if (data.code == 0) {
        //caseinfo,parties, claims, causes
        var caseOptions = {};
        if (data.caseinfo.caseOptions != null) {
          caseOptions = JSON.parse(data.caseinfo.caseOptions);
        }
        setCase({ ...data.caseinfo, ...caseOptions });

        setParties(data.parties);
        setPartyOptions(data.parties);
        setSelectedCauses(data.causes.filter((d) => d.causeId != null));
        setOtherCauses(data.causes.filter((d) => d.causeId == null));
        setMotions(data.motions);

        if (data.motions && data.motions.length > 0) {
          setIsMotion(true);
        }
        if (data.fiat) {
          setNewFiat(false);
          setIsFiat(true);
          setFiatUrl(Constants.AbsoluteFiletoRelative(data.fiat.doc));
          console.log(Constants.AbsoluteFiletoRelative(data.fiat.doc));
          setFiat({ ...data.fiat, filename: "Fiat on Record" });
          console.log("set Fiat");
        } else {
          // Ensure FIAT state is properly reset if no FIAT exists
          setIsFiat(false);
          setFiat(null);
          setFiatUrl("");
        }
        setClaims(data.claims);

        if (data.fee.length > 0) {
          setcasefeeId(data.fee[0].id);
        }

        if (flow.pos == 1) {
          if (data.fee.length > 0) {
            //the payment part is the needed
            setFlow({ pos: 9, code: "payment" });
          } else if (data.motions.length > 0) {
            //goto gazette part, it means it already have motion
            setFlow({ pos: 8, code: "gazette" });
          } else {
            //goto claims
            setFlow({ pos: 6, code: "claims" });
          }
        }
      } else if (data.code == -10) {
        setIsExpired(true);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  const onRemoveCause = async (id) => {
    //for account registration
    try {
      setLoading(true);
      const resp = await fetch(
        `${Constants.apiUrl}/filing/remove-cause/${id}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const data = await resp.json();
      setLoading(false);
      if (data.code == 0) {
        //caseinfo,parties, claims, causes
        console.log(data);
      } else if (data.code == -10) {
        setIsExpired(true);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  const onRemoveParty_Server = async (id) => {
    //for account registration
    try {
      setLoading(true);
      const resp = await fetch(
        `${Constants.apiUrl}/filing/remove-party/${id}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const data = await resp.json();
      setLoading(false);
      if (data.code == 0) {
        //caseinfo,parties, claims, causes
        console.log(data);
      } else if (data.code == -10) {
        setIsExpired(true);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };
  const onRemoveClaim_Server = async (id) => {
    //for account registration
    try {
      setLoading(true);
      const resp = await fetch(
        `${Constants.apiUrl}/filing/remove-claim/${id}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const data = await resp.json();
      setLoading(false);
      if (data.code == 0) {
        //caseinfo,parties, claims, causes
        console.log(data);
      } else if (data.code == -10) {
        setIsExpired(true);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  const onGetLgs = async (stateid) => {
    console.log(stateid);
    //for account registration
    try {
      setLocs({ ...locs, lga: false });
      const resp = await fetch(`${Constants.apiUrl}/profile/lgs/${stateid}`, {
        method: "GET",
        headers: { "Content-Type": "application/json", Authorization: "" },
      });
      const data = await resp.json();
      setLga(data);
      setLocs({ ...locs, lga: true });
    } catch (error) {
      setLocs({ ...locs, lga: null });
      console.error(error);
    }
  };

  const onGetCities = async (lgid) => {
    //for account registration
    try {
      setLocs({ ...locs, city: false });

      const resp = await fetch(`${Constants.apiUrl}/profile/cities/${lgid}`, {
        method: "GET",
        headers: { "Content-Type": "application/json", Authorization: "" },
      });
      const data = await resp.json();
      setCities(data);
      setLocs({ ...locs, city: true });
    } catch (error) {
      setLocs({ ...locs, city: null });
      console.error(error);
    }
  };

  const onCaseChange = (e) => {
    console.log(e.target.name, e.target.value);
    setCase({ ...cinfo, [e.target.name]: e.target.value });
  };

  const onLegalChange = () => {
    //see list of legal
    setShowLegals(true);
  };

  const onChangeOtherCause = (index, key, value) => {
    setOtherCauses((prev) =>
      prev.map((item, i) => (i === index ? { ...item, [key]: value } : item)),
    );
  };

  const onRemoveOtherCause = async (index) => {
    setRemovingIndex(index);
    //check if object has an id
    const h = otherCauses[index];
    if (h.id > 0) {
      await onRemoveCause(h.id);
    }
    setTimeout(() => {
      setOtherCauses((prev) => prev.filter((_, i) => i !== index));
      setRemovingIndex(null);
    }, 300); // match fadeOut duration
  };

  const onAddOtherCause = () => {
    setOtherCauses((prev) => [...prev, { id: 0, description: "" }]);
  };

  const onSaveParty = (e) => {
    setFlowError("");
    var _party = { ...e, isOrg: party.isOrg == "1" ? true : false };
    setParties((prev) => [...prev, _party]);
  };
  const onRemoveParty = async (index) => {
    const h = parties[index];
    if (h && h.id > 0) {
      await onRemoveParty_Server(h.id);
    }
    setRemovingIndex(index);
    setTimeout(() => {
      setParties((prev) => prev.filter((_, i) => i !== index));
      setRemovingIndex(null);
    }, 300); // match fadeOut duration
  };

  const onEditParty = (row, index) => {
    setRemovingIndex(index);
    setTimeout(() => {
      setParties((prev) => prev.filter((_, i) => i !== index));
      setRemovingIndex(null);
    }, 300); // match fadeOut duration

    //remove that one and allow it to be edited
    setParty(row);
  };

  const onSave = async () => {
    /* const caseOptions ={isDelarative:cinfo.isDelarative,isRequireInterpretation :cinfo.isRequireInterpretation,
    isLegalPolicy:cinfo.isLegalPolicy, isLegalPosition: cinfo.isLegalPosition,isEmergency: cinfo.isEmergency,isDispute : cinfo.isDispute, isUniform: cinfo.isUniform} */

    // Save current form state before submission
    const currentFormState = {
      cinfo,
      selectedCauses,
      otherCauses,
      fiat,
      claims,
      parties,
      motions,
      isMotion,
      isFiat,
      fiatUrl,
    };
    setSavedFormState(currentFormState);

    const caseOptions = {
      isDelarative: cinfo.isDelarative,
      isRequireInterpretation: cinfo.isRequireInterpretation,
      isLegalPolicy: cinfo.isLegalPolicy,
      isLegalPosition: cinfo.isLegalPosition,
      isEmergency: cinfo.isEmergency,
      isDispute: cinfo.isDispute,
      isUniform: cinfo.isUniform,
    };

    var caseFilingId = 1;
    console.log("the printed options");
    console.log(caseOptions);
    const hasAnyFalse = Object.values(caseOptions).some((v) => v === false);
    if (hasAnyFalse) {
      caseFilingId = 2;
      console.log("At least one option is false. meanning its ADR");
    }
    var caseinfo = {
      ...cinfo,
      caseFilingId,
      caseOptions: JSON.stringify(caseOptions),
      isPublic: cinfo.isPublic == "1" ? true : false,
    };
    var _fiat = null;
    if (isNewFiat) {
      var _fiat = { doc: fiat?.base64, isPay: true };
    }
    //isPay is just to brng in file

    // Map selectedCauses to only include id and title (clean format for API)
    const cleanSelectedCauses = selectedCauses?.map((sc) => ({
      id: sc.causeId ? sc.id : 0,
      causeId: sc.causeId || sc.caseCatId,
      description: sc.description || sc.title,
    }));

    const stringObjects = otherCauses?.map((oc) => ({
      id: oc.id || 0,
      causeId: 0,
      description: oc.description,
    }));

    //var _othercauses= otherCauses;
    var _causes = [...cleanSelectedCauses, ...stringObjects];

    // claimstr: '', currency: '', value: ''
    var _claims = claims; //need to be inter prepreted as {claim,ClaimValue,CurrencyType}
    var casefiling = {
      cinfo: caseinfo,
      fiat: _fiat,
      parties,
      causes: _causes,
      claims,
      motions,
    };

    //make sure the motion is order49
    console.log('here to post filing');
    setLoading(true);
    try {
      const resp = await fetch(`${Constants.apiUrl}/filing`, {
        method: "POST",
        body: JSON.stringify(casefiling),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await resp.json();
      setLoading(false);

      //   setFlow({pos:6,code:"congrat"})
      localStorage.removeItem("caseinfo");

      if (data.code == 0) {
        // setIsSuccess(true);
        //process the flow and update the field.
        setCase({
          ...cinfo,
          caseId: data.caseId,
          referenceNumber: data.referenceNumber,
        });
        onDeleteFromLocal();
        setPartyOptions(data.partyOptions);
        onLoadCase(data.caseId); // to reload all the information with their respective ids
        // Clear saved state on success
        setSavedFormState(null);
      } else if (data.code == -10) {
        setIsExpired(true);
        // Restore form state on error
        restoreFormState(currentFormState);
      } else {
        console.log(data);
        console.log(`the error received.`);
        setFlowError(data.satus);
        // Restore form state on error
        restoreFormState(currentFormState);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
      setFlowError("cannot connect to the server at the moment. Try again");
      // Restore form state on error
      restoreFormState(currentFormState);
      // onMove();
    }
  };

  const restoreFormState = (formState) => {
    if (formState) {
      // Restore case info first to trigger causeOfActions loading
      setCase(formState.cinfo);

      // Use setTimeout to ensure state updates happen after cinfo is set
      // This allows the useEffect for causeOfActions to trigger first
      setTimeout(() => {
        setSelectedCauses(formState.selectedCauses || []);
        setOtherCauses(formState.otherCauses || []);
        setFiat(formState.fiat);
        setClaims(formState.claims || []);
        setParties(formState.parties || []);
        setMotions(formState.motions || []);
        setIsMotion(formState.isMotion || false);
        setIsFiat(formState.isFiat || false);
        if (formState.fiatUrl) {
          setFiatUrl(formState.fiatUrl);
        }
      }, 0);
    }
  };
  const isCauseSelected = (id) => {
    return selectedCauses.some((item) => item.causeId === id);
  };
  const onSelectedCause = async ({ opt, value }) => {
    setFlowError("");
    //check if on server
    if (!value) {
      const h = selectedCauses.find((item) => item.causeId == opt.id);
      if (h && h.id > 0) {
        await onRemoveCause(h.id);
      }
    }

    setSelectedCauses((prev) => {
      if (value) {
        // Add if not already present
        if (!prev.some((item) => item.causeId === opt.id)) {
          return [...prev, { causeId: opt.id, description: opt.title }];
        }
        return prev;
      } else {
        // Remove

        return prev.filter((item) => item.causeId !== opt.id);
      }
    });
  };

  const onChangeClaim = (index, key, value) => {
    setClaims((prev) =>
      prev.map((item, i) => (i === index ? { ...item, [key]: value } : item)),
    );
  };

  const onRemoveClaims = async (index) => {
    if (claims.length == 1) {
      return;
    }

    const h = claims[index];
    if (h && h.id > 0) {
      await onRemoveClaim_Server(h.id);
    }
    setRemovingIndex(index);
    setTimeout(() => {
      setClaims((prev) => prev.filter((_, i) => i !== index));
      setRemovingIndex(null);
    }, 300); // match fadeOut duration
  };

  const onAddClaim = () => {
    setClaims((prev) => [
      ...prev,
      { claim: "", claimValue: "", currencyType: "" },
    ]);
  };

  const onChangePrayer = (index, key, value) => {
    setPrayers((prev) =>
      prev.map((item, i) => (i === index ? { ...item, [key]: value } : item)),
    );
  };

  const onRemovePrayer = async (index) => {
    if (motionPrayers.length == 1) {
      return;
    }
    const h = motionPrayers[index];
    if (h && h.id > 0) {
      await onRemovePrayer_Server(h.id);
    }
    setRemovingIndex(index);
    setTimeout(() => {
      setPrayers((prev) => prev.filter((_, i) => i !== index));
      setRemovingIndex(null);
    }, 300); // match fadeOut duration
  };
  const onRemovePrayer_Server = async (id) => {
    //for account registration
    try {
      setLoading(true);
      const resp = await fetch(
        `${Constants.apiUrl}/filing/remove-prayer/${id}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const data = await resp.json();
      setLoading(false);
      if (data.code == 0) {
        //caseinfo,parties, claims, causes
        console.log(data);
      } else if (data.code == -10) {
        setIsExpired(true);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  const onAddPrayer = () => {
    setPrayers((prev) => [...prev, { prayer: "" }]);
  };

  const onMotionChange = (e) => {
    setMotion({ ...motion, [e.target.name]: e.target.value });
  };
  const onSaveMotion = (e) => {
    e.preventDefault();
    // setParties({...parties,party});
    setMotions((prev) => [...prev, { ...motion, motionPrayers }]);
    setMotion({ partyId: "", motionClassificationId: "", motionTypeId: "" });
    setPrayers([{ prayer: "" }]);
  };

  const onRemoveMotion_Server = async (id) => {
    //for account registration
    try {
      setLoading(true);
      const resp = await fetch(
        `${Constants.apiUrl}/filing/remove-motion/${id}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const data = await resp.json();
      setLoading(false);
      if (data.code == 0) {
        //caseinfo,parties, claims, causes
        console.log(data);
      } else if (data.code == -10) {
        setIsExpired(true);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };
  const onRemoveMotion = async (index) => {
    const h = motionPrayers[index];
    if (h && h.id > 0) {
      await onRemoveMotion_Server(h.id);
    }
    setRemovingIndex(index);
    setTimeout(() => {
      setMotions((prev) => prev.filter((_, i) => i !== index));
      setRemovingIndex(null);
    }, 300); // match fadeOut duration
  };

  const onEditMotion = (row, index) => {
    setRemovingIndex(index);
    setTimeout(() => {
      setMotions((prev) => prev.filter((_, i) => i !== index));
      setRemovingIndex(null);
    }, 300); // match fadeOut duration

    //remove that one and allow it to be edited
    setMotion(row);
    setPrayers(row.motionPrayers);
  };
  const onGazetteProceed = (e) => {
    console.log("after processing... here is value");
    console.log(e);
    setcasefeeId(e.feeid);
    setIsSuccess(e.isPaid);
    if (!e.isPaid) {
      on_gazette();
    }
  };

  const handleUploadChange = async (e) => {
    const files = e.target.files;
    setFiatUrl(URL.createObjectURL(files[0]));
    console.log("file document");
    console.log(files[0]);
    var b64 = await Constants.toBase64(files[0]);

    var objUline = {
      doc: files[0],
      base64: b64.split(",")[1],
      filename: Constants.ReduceFilename(files[0]?.name),
      base64Ext: b64.split(",")[0],
      isPay: true,
    }; //using isPay to indicate new fiat
    setFiat(objUline);
    setNewFiat(true);
    onPreview(objUline);
  };

  const onPreview = async (id, uline) => {
    const uploadurl = `${Constants.apiUrl}/gazette/uploadDocument/preview/${id}`;

    // var updateditems=new Set(items);
    // Sending the FormData using fetch
    setLoading(true);
    fetch(uploadurl, {
      method: "POST",
      body: JSON.stringify(uline),
      headers: {
        "Content-Type": "application/json",
        Authorization: "",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setLoading(false);
        console.log("preview details");
        console.log(data);
        if (data.code == 0) {
          //saved already
          var updated = { ...uline, prev: data };
        } else if (data.code == -10) {
          setIsExpired(true);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        setLoading(false);
      });
  };

  return (
    <div className="filing-case">
      {/* <div style={{ textAlign: "center" }}>
        <h2>{cinfo?.caseTitle?.toUpperCase()}</h2>
        <h3>{cinfo.referenceNumber}</h3>
      </div> */}

      <CaseHeader onClick={generalBackFn} />
      <div className="multiform filing-case-container">
        <div className="flow">
          <div className="itemgroup">
            <FlowItem
              flow={flow}
              pos={1}
              code="case_details"
              title="Case Details"
            />
            <FlowItem flow={flow} pos={5} code="parties" title="Parties" />
            <FlowItem
              flow={flow}
              pos={6}
              code="claims"
              title={cinfo.caseTypeId == 2 ? "Offences" : "Claims"}
            />
            {isMotion && (
              <FlowItem flow={flow} pos={7} code="motions" title="Motions" />
            )}
            <FlowItem flow={flow} pos={8} code="gazette" title="Gazette" />
            <FlowItem
              flow={flow}
              pos={9}
              code="payment"
              title="Payment"
              isLast={true}
            />
          </div>
        </div>
        {flow.code == "case_details" && (
          <div className="view">
            <form
              onSubmit={on_case_details}
              className="filing-court-process-form"
            >
              <h2 className="form-step-title ">FILING OF COURT PROCESS</h2>
              <div className="case-filing-details-section">
                <div className="input-group">
                  <label>Parties to the Case</label>
                  <div className="input-wrapper">
                    <DynamicIcon iname="person_3" />
                    <input
                      placeholder="Parties to the Case"
                      required={true}
                      name="caseTitle"
                      maxLength={300}
                      value={cinfo.caseTitle?.toUpperCase()}
                      onChange={onCaseChange}
                    />
                  </div>
                </div>

                <div className="filing-case-type-details-container">
                  <div className="select-group">
                    <label> Case Type</label>
                    <select
                      name="caseTypeId"
                      value={cinfo.caseTypeId}
                      required={true}
                      onChange={onCaseChange}
                    >
                      <option value="">Select </option>
                      {frequentData?.casetype.map((opt) => (
                        <option key={opt.id} value={opt.id}>
                          {opt.caseType1}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="select-group">
                    <label> Classification</label>
                    <select
                      name="caseCategoryId"
                      value={cinfo.caseCategoryId}
                      required={true}
                      onChange={onCaseChange}
                    >
                      <option value="">Select </option>
                      {frequentData?.casecategories
                        .filter((c) => c.caseTypeId == cinfo.caseTypeId)
                        .map((opt) => (
                          <option key={opt.id} value={opt.id}>
                            {opt.categoryTitle}
                          </option>
                        ))}
                    </select>
                  </div>

                  <div className="select-group">
                    <label> Case Origin</label>
                    <select
                      name="caseOriginId"
                      value={cinfo.caseOriginId}
                      required={true}
                      onChange={onCaseChange}
                    >
                      <option value="">Select </option>
                      {frequentData?.caseorigin.map((opt) => (
                        <option key={opt.id} value={opt.id}>
                          {opt.title}{" "}
                          {opt.id == 3 &&
                            "(if this case was previously filed at Magistrate Court)"}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="select-group">
                    <label> Mode of Process</label>
                    <select
                      name="processType"
                      value={cinfo.processType}
                      required={true}
                      onChange={onCaseChange}
                    >
                      {processmode.map((opt) => (
                        <option key={opt.value} value={opt.value}>
                          {opt.label}
                        </option>
                      ))}
                      {isVacation && <option value="Vacation">Vacation</option>}
                    </select>
                  </div>
                </div>
                {cinfo.caseOriginId == 3 && (
                  <div className="input-group">
                    <label>Magistrate Suit/Charge Number </label>
                    <div className="input-wrapper">
                      <DynamicIcon iname="group" />
                      <input
                        placeholder="Magistrate Suit/Charge Number"
                        required={true}
                        name="oldCaseNumber"
                        value={cinfo.oldCaseNumber}
                        onChange={onCaseChange}
                      />
                    </div>
                  </div>
                )}
                <div className="filing-case-details-container">
                  <div className="input-group">
                    <label>Number of Witnesses</label>
                    <div className="input-wrapper">
                      <input
                        placeholder="Number of Witnesses"
                        required={true}
                        name="witness"
                        type="number"
                        value={cinfo.witness}
                        onChange={onCaseChange}
                      />
                    </div>
                  </div>
                  <div className="select-group">
                    <label> Division</label>
                    <select
                      name="divisionId"
                      value={cinfo.divisionId}
                      required={true}
                      onChange={onCaseChange}
                    >
                      <option value="">Select </option>
                      {frequentData?.divisions.map((opt) => (
                        <option key={opt.id} value={opt.id}>
                          {opt.title}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="select-group">
                    <label> Case Identity</label>
                    <select
                      name="isPublic"
                      value={cinfo.isPublic}
                      required={true}
                      onChange={onCaseChange}
                    >
                      {caseidentity.map((opt) => (
                        <option key={opt.value} value={opt.value}>
                          {opt.label}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="select-group">
                    <label>
                      {" "}
                      State <span className="required">*</span>
                    </label>
                    <select
                      name="stateId"
                      required={true}
                      value={cinfo.stateId}
                      onChange={onCaseChange}
                    >
                      {locs.state == null && (
                        <option value="">Select state</option>
                      )}
                      {locs.state == false && (
                        <option value="">loading state</option>
                      )}
                      {locs.state && <option value="">Select state</option>}
                      {states.map((opt) => (
                        <option key={opt.id} value={opt.id}>
                          {opt.title}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="select-group">
                    <label>
                      {" "}
                      L.G.A <span className="required">*</span>
                    </label>
                    <select
                      name="LocalGovtAreaId"
                      value={cinfo.LocalGovtAreaId}
                      required={true}
                      onChange={onCaseChange}
                    >
                      {locs.lga == null && (
                        <option value="">Select State first</option>
                      )}
                      {locs.lga == false && (
                        <option value="">loading LG</option>
                      )}
                      {locs.lga && <option value="">Select LG</option>}
                      {Lga.map((opt) => (
                        <option key={opt.id} value={opt.id}>
                          {opt.title}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="select-group">
                    <label>
                      {" "}
                      City <span className="required">*</span>
                    </label>
                    <select
                      name="cityId"
                      value={cinfo.cityId}
                      required={true}
                      onChange={onCaseChange}
                    >
                      {locs.city == null && (
                        <option value="">Select LGA first</option>
                      )}
                      {locs.city == false && (
                        <option value="">loading cities</option>
                      )}
                      {locs.city && <option value="">Select city</option>}
                      {cities.map((opt) => (
                        <option key={opt.id} value={opt.id}>
                          {opt.title}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                {/* {profile.isLawFirm && (
                  <div style={{ display: "flex" }}>
                    <div className="input-group">
                      <label>
                        {" "}
                        Legal Counsel<span className="required">*</span>
                      </label>
                      <div className="input-wrapper">
                        <DynamicIcon iname="balance" />
                        <input
                          placeholder="Legal Counsel"
                          disabled
                          value={legal.name}
                        />
                      </div>
                    </div>
                    <div style={{ justifyContent: "end" }}>
                      <JisButton icon={"balance"} onClick={onLegalChange}>
                        Change Legal Counsel
                      </JisButton>
                    </div>
                  </div>
                )} */}
              </div>
              <div className="case-filing-checkbox-section">
                <div className="case-filing-checkbox-group">
                  <div>
                    <div className="case-filing-checkbox-container">
                      <input
                        type="checkbox"
                        id="case-filing-religious-body"
                        className="case-filing-checkbox"
                        checked={cinfo.IsReligious}
                        onChange={(e) =>
                          setCase({ ...cinfo, IsReligious: e.target.checked })
                        }
                      />
                      <label
                        htmlFor="case-filing-religious-body"
                        className="case-filing-checkbox-label"
                      >
                        Check this box if this case is being filed by a
                        religious body
                      </label>
                    </div>
                    {/* <JisCheckbox
                      label="Check this box if this case is being filed by a religious body"
                      value={cinfo.IsReligious}
                      onChange={(e) => setCase({ ...cinfo, IsReligious: e })}
                    /> */}
                    {cinfo.IsReligious && (
                      <div
                        style={{
                          marginTop: "8px",
                        }}
                        className="select-group"
                      >
                        <label> Religion Group</label>
                        <select
                          required={true}
                          name="religiousGroup"
                          maxLength={50}
                          value={cinfo.religiousGroup}
                          onChange={onCaseChange}
                        >
                          <option value="">Select </option>
                          <option>Christanity</option>
                          <option>Islam</option>
                          <option>Traditional</option>
                          <option>Others</option>
                        </select>
                      </div>
                    )}
                  </div>
                  {cinfo.IsReligious && (
                    <div className="input-group">
                      <label>Religious Name</label>
                      <div className="input-wrapper">
                        <DynamicIcon iname="group" />
                        <input
                          placeholder="Religious Name"
                          required={true}
                          name="religiousName"
                          maxLength={50}
                          value={cinfo.religiousName}
                          onChange={onCaseChange}
                        />
                      </div>
                    </div>
                  )}
                  <div style={{ display: "flex" }}>
                    <div className="case-filing-checkbox-container">
                      <input
                        type="checkbox"
                        id="case-filing-fiat"
                        className="case-filing-checkbox"
                        checked={isFiat}
                        onChange={(e) => setIsFiat(e.target.checked)}
                      />
                      <label
                        htmlFor="case-filing-fiat"
                        className="case-filing-checkbox-label"
                      >
                        Check this box if you have FIAT to this case
                      </label>
                    </div>
                    {/* <JisCheckbox
                      label="Check this box if you have FIAT  to this case"
                      value={isFiat}
                      onChange={(e) => setIsFiat(e)}
                    /> */}
                    {isFiat && (
                      <div className="btn-upload">
                        <input
                          type="file"
                          name="fiatdoc"
                          accept="application/pdf"
                          id={`file-fiat`}
                          onChange={(e) => handleUploadChange(e)}
                        />
                        <label htmlFor={`file-fiat`} title={fiat?.name}>
                          {fiat == null
                            ? "Click to upload FIAT document"
                            : Constants.ReduceString(fiat?.filename, 30)}
                        </label>
                        {fiat != null && (
                          <JisButton
                            onClick={() => setIsPreview(true)}
                            icon="preview"
                          >
                            Preview Fiat Document
                          </JisButton>
                        )}
                        {fiat == null && <div style={{ color: "red" }}>*</div>}
                      </div>
                    )}
                  </div>
                </div>

                <div className="filing-court-multi-select">
                  <p>Cause Of Action</p>

                  <MultiSelectDropdown
                    options={causeOfActions}
                    placeholder="Select cause(s) of action"
                    onChange={setSelectedCauses}
                    value={selectedCauses}
                  />

                  {flowerror && <div className="flowerror">{flowerror}</div>}
                </div>

                <div>
                  <div className="case-filing-checkbox-container">
                    <input
                      type="checkbox"
                      id="other-cause-of-action"
                      className="case-filing-checkbox"
                      checked={otherCauses.length >= 1}
                      onChange={() => {
                        if (otherCauses.length === 0) {
                          onAddOtherCause();
                        }
                      }}
                    />
                    <label
                      htmlFor="other-cause-of-action"
                      className="case-filing-checkbox-label"
                    >
                      Other Cause of Action{" "}
                    </label>
                  </div>
                  {/* <p>
                        For additional cause of action not listed, please click
                        the "Add other Causes" button below:
                      </p> */}
                  {otherCauses?.map((opt, index) => (
                    <div
                      key={index}
                      className={`cause-item other-cause-of-action ${
                        removingIndex === index ? "removing" : ""
                      }`}
                    >
                      <div className="input-group">
                        <div className="other-cause-of-action-label-container">
                          <label>Other Cause Of Action {index + 1}</label>

                          <div
                            onClick={() => onRemoveOtherCause(index)}
                            className="delete"
                          >
                            <DynamicIcon size={24} iname="trash-2" />{" "}
                            <p>Delete</p>
                          </div>
                        </div>
                        <div className="input-wrapper">
                          {/* <DynamicIcon iname="group" /> */}
                          <input
                            placeholder="Enter Cause of Action"
                            required
                            value={opt.description}
                            maxLength={290}
                            onChange={(e) =>
                              onChangeOtherCause(
                                index,
                                "description",
                                e.target.value,
                              )
                            }
                          />
                        </div>
                      </div>
                    </div>
                  ))}

                  {otherCauses.length >= 1 && (
                    <div className="other-cause-of-action">
                      <JisButton icon="add" onClick={onAddOtherCause}>
                        Add Other Causes
                      </JisButton>
                    </div>
                  )}
                </div>
              </div>

              <div style={{ margin: "auto" }}>
                {/* <div> */}
                <h2 className="form-step-title">Select Option(s)</h2>
                {/* <p>Check the option(s) applicable from below: </p>
                </div> */}

                <div className="select-options-container filing-case-options-container">
                  <JisYesNo
                    label="Is Declarative Order Sought?"
                    value={cinfo.isDelarative}
                    onChange={(e) => setCase({ ...cinfo, isDelarative: e })}
                  />

                  <JisYesNo
                    label="Does the case require Legal Interpretation?"
                    value={cinfo.isRequireInterpretation}
                    onChange={(e) =>
                      setCase({ ...cinfo, isRequireInterpretation: e })
                    }
                  />
                  <JisYesNo
                    label="Is legal policy or constitutional issues that necessitate a binding and public precedent involved?"
                    value={cinfo.isLegalPolicy}
                    onChange={(e) => setCase({ ...cinfo, isLegalPolicy: e })}
                  />
                  <JisYesNo
                    label="Is declaration of the legal position or interpretation of an instrument or policy document involved?"
                    value={cinfo.isLegalPosition}
                    onChange={(e) => setCase({ ...cinfo, isLegalPosition: e })}
                  />
                  <JisYesNo
                    label="Is emergency injunctive relief sought or party needed to maintain status quo?"
                    value={cinfo.isEmergency}
                    onChange={(e) => setCase({ ...cinfo, isEmergency: e })}
                  />
                  <JisYesNo
                    label="Does the dispute significantly affect non-parties?"
                    value={cinfo.isDispute}
                    onChange={(e) => setCase({ ...cinfo, isDispute: e })}
                  />
                  <JisYesNo
                    label="Is there a need for uniform treatment towards an issue or disputant?"
                    value={cinfo.isUniform}
                    onChange={(e) => setCase({ ...cinfo, isUniform: e })}
                  />
                </div>
              </div>

              <button className="fill-btn-solid submit-button" type="submit">
                Proceed
              </button>
            </form>
          </div>
        )}

        {flow.code == "claims" && (
          <div className="view enter-your-claim-form-container">
            <h2 className="form-step-title">Enter your Claim</h2>

            <form onSubmit={on_claims}>
              {claims.map((claim, index) => (
                <div
                  key={index}
                  className={`claim-item ${
                    removingIndex === index ? "removing" : ""
                  }`}
                >
                  <div style={{ flex: 1 }}>
                    <div className="input-group claims">
                      <div className="claims-label-wrapper">
                        <label>
                          {cinfo.caseTypeId == 2 ? "Offences" : "Claims"}{" "}
                        </label>

                        <div
                          onClick={() => onRemoveClaims(index)}
                          className="delete"
                        >
                          <svg
                            width={24}
                            height={24}
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M20.9997 6.73046C20.9797 6.73046 20.9497 6.73046 20.9197 6.73046C15.6297 6.20046 10.3497 6.00046 5.11967 6.53046L3.07967 6.73046C2.65967 6.77046 2.28967 6.47046 2.24967 6.05046C2.20967 5.63046 2.50967 5.27046 2.91967 5.23046L4.95967 5.03046C10.2797 4.49046 15.6697 4.70046 21.0697 5.23046C21.4797 5.27046 21.7797 5.64046 21.7397 6.05046C21.7097 6.44046 21.3797 6.73046 20.9997 6.73046Z"
                              fill="#FF2E3B"
                            />
                            <path
                              d="M8.49977 5.72C8.45977 5.72 8.41977 5.72 8.36977 5.71C7.96977 5.64 7.68977 5.25 7.75977 4.85L7.97977 3.54C8.13977 2.58 8.35977 1.25 10.6898 1.25H13.3098C15.6498 1.25 15.8698 2.63 16.0198 3.55L16.2398 4.85C16.3098 5.26 16.0298 5.65 15.6298 5.71C15.2198 5.78 14.8298 5.5 14.7698 5.1L14.5498 3.8C14.4098 2.93 14.3798 2.76 13.3198 2.76H10.6998C9.63977 2.76 9.61977 2.9 9.46977 3.79L9.23977 5.09C9.17977 5.46 8.85977 5.72 8.49977 5.72Z"
                              fill="#FF2E3B"
                            />
                            <path
                              d="M15.2104 22.7496H8.79039C5.30039 22.7496 5.16039 20.8196 5.05039 19.2596L4.40039 9.18959C4.37039 8.77959 4.69039 8.41959 5.10039 8.38959C5.52039 8.36959 5.87039 8.67959 5.90039 9.08959L6.55039 19.1596C6.66039 20.6796 6.70039 21.2496 8.79039 21.2496H15.2104C17.3104 21.2496 17.3504 20.6796 17.4504 19.1596L18.1004 9.08959C18.1304 8.67959 18.4904 8.36959 18.9004 8.38959C19.3104 8.41959 19.6304 8.76959 19.6004 9.18959L18.9504 19.2596C18.8404 20.8196 18.7004 22.7496 15.2104 22.7496Z"
                              fill="#FF2E3B"
                            />
                            <path
                              d="M13.6601 17.25H10.3301C9.92008 17.25 9.58008 16.91 9.58008 16.5C9.58008 16.09 9.92008 15.75 10.3301 15.75H13.6601C14.0701 15.75 14.4101 16.09 14.4101 16.5C14.4101 16.91 14.0701 17.25 13.6601 17.25Z"
                              fill="#FF2E3B"
                            />
                            <path
                              d="M14.5 13.25H9.5C9.09 13.25 8.75 12.91 8.75 12.5C8.75 12.09 9.09 11.75 9.5 11.75H14.5C14.91 11.75 15.25 12.09 15.25 12.5C15.25 12.91 14.91 13.25 14.5 13.25Z"
                              fill="#FF2E3B"
                            />
                          </svg>
                          Delete
                        </div>
                      </div>
                      <div className="input-wrapper">
                        {/* <DynamicIcon iname="group" /> */}
                        <input
                          placeholder="e.g Money Laundering"
                          required={true}
                          value={claim.claim}
                          onChange={(e) =>
                            onChangeClaim(index, "claim", e.target.value)
                          }
                        />
                      </div>
                    </div>

                    {cinfo.caseTypeId != 2 && (
                      <div className="currency-container">
                        <div className="select-group">
                          <label>Currency Type</label>
                          <select
                            name="gender"
                            value={claim.currencyType}
                            required={
                              claim.claimValue && claim.claimValue.trim() !== ""
                            }
                            onChange={(e) =>
                              onChangeClaim(
                                index,
                                "currencyType",
                                e.target.value,
                              )
                            }
                          >
                            <option value="">Select </option>
                            {currencies.map((opt) => (
                              <option key={opt.value} value={opt.value}>
                                {opt.label}
                              </option>
                            ))}
                          </select>
                        </div>

                        <div className="input-group">
                          <label> Claim Value (Numbers only) </label>
                          <div className="input-wrapper">
                            <DynamicIcon iname="money" />
                            <input
                              required={
                                claim.currencyType && claim.currencyType !== ""
                              }
                              placeholder="eg 300"
                              value={Constants.formatCurrency(claim.claimValue)}
                              onChange={(e) =>
                                onChangeClaim(
                                  index,
                                  "claimValue",
                                  e.target.value,
                                )
                              }
                            />
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              ))}
              <button className="add-claim-action-btn" onClick={onAddClaim}>
                Add {cinfo.caseTypeId == 2 ? "Offence" : "Claim"}
              </button>

              <button
                className="fill-btn-solid submit-button"
                type="submit"
                loading={loading}
              >
                Continue
              </button>
              {/* <div className="flowbuttongroup">
                <JisButton onClick={on_claims_back}>Back</JisButton>
              </div> */}
            </form>
          </div>
        )}

        {flow.code == "parties" && (
          <div className="view">
            <h2 className="form-step-title">Add Parties to the case</h2>

            {/* <span style={{ color: "red", fontWeight: "bold" }}>
               Select at least one party as the lead party 
            </span> */}
            <JisParty onSave={onSaveParty} defaultParty={party} />
            {parties.length > 0 && (
              <div
                className="parties-to-the-case-table"
                style={{ maxWidth: "100%" }}
              >
                <div class="table-header">
                  <span>Parties</span>
                  {/* <span className="total">{parties.length}</span> */}
                </div>
                <div className="table-wrapper">
                  <table className="case-details-table full-border">
                    <tr>
                      <th className="col-title">Name</th>
                      <th className="col-medium">Party Type</th>
                      <th>Phone Number</th>
                      <th className="col-title">Email</th>
                      <th>Lead</th>
                      <th className="col-title">Address</th>
                      <th className="col-action">Edit</th>
                      <th className="col-action">Remove</th>
                    </tr>
                    {parties?.map((opt, index) => (
                      <tr key={index}>
                        <td>
                          {opt.firstName || opt.lastName || opt.middleName
                            ? `${opt.firstName} ${opt.middleName ?? ""} ${
                                opt.lastName ?? ""
                              }`
                            : "N/A"}
                        </td>
                        <td>
                          {Constants.getItemById(
                            frequentData?.partyTypes,
                            opt.partyTypeId,
                          )?.title || "N/A"}{" "}
                        </td>
                        <td>{opt.primaryContactNumber || "N/A"}</td>
                        <td>{opt.primaryEmail || "N/A"}</td>
                        <td>{opt.isLeadParty ? "Yes" : "No"}</td>
                        <td>{opt.address1 || "N/A"}</td>
                        <td>
                          <JisButton
                            variant="plain"
                            onClick={() => onEditParty(opt, index)}
                          >
                            <svg
                              width={24}
                              height={24}
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M13.2603 3.59924L5.05034 12.2892C4.74034 12.6192 4.44034 13.2692 4.38034 13.7192L4.01034 16.9592C3.88034 18.1292 4.72034 18.9292 5.88034 18.7292L9.10034 18.1792C9.55034 18.0992 10.1803 17.7692 10.4903 17.4292L18.7003 8.73924C20.1203 7.23924 20.7603 5.52924 18.5503 3.43924C16.3503 1.36924 14.6803 2.09924 13.2603 3.59924Z"
                                stroke="#292D32"
                                strokeWidth="1.5"
                                strokeMiterlimit={10}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M11.8896 5.05078C12.3196 7.81078 14.5596 9.92078 17.3396 10.2008"
                                stroke="#292D32"
                                strokeWidth="1.5"
                                strokeMiterlimit={10}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M3 22H21"
                                stroke="#292D32"
                                strokeWidth="1.5"
                                strokeMiterlimit={10}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </JisButton>
                        </td>
                        <td>
                          <JisButton
                            variant="plain"
                            onClick={() => onRemoveParty(index)}
                          >
                            <svg
                              width={24}
                              height={24}
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M21 5.98047C17.67 5.65047 14.32 5.48047 10.98 5.48047C9 5.48047 7.02 5.58047 5.04 5.78047L3 5.98047"
                                stroke="#FF2E3B"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M8.5 4.97L8.72 3.66C8.88 2.71 9 2 10.69 2H13.31C15 2 15.13 2.75 15.28 3.67L15.5 4.97"
                                stroke="#FF2E3B"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M18.8504 9.14062L18.2004 19.2106C18.0904 20.7806 18.0004 22.0006 15.2104 22.0006H8.79039C6.00039 22.0006 5.91039 20.7806 5.80039 19.2106L5.15039 9.14062"
                                stroke="#FF2E3B"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M10.3301 16.5H13.6601"
                                stroke="#FF2E3B"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M9.5 12.5H14.5"
                                stroke="#FF2E3B"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </JisButton>
                        </td>
                      </tr>
                    ))}
                  </table>
                </div>
              </div>
            )}
            <div className="custom-max-width">
              <div className="flowerror">{flowerror}</div>
              <button className="fill-btn-solid" onClick={on_parties}>
                Proceed
              </button>
            </div>
          </div>
        )}
        {flow.code == "motions" && (
          <div>
            <div className="view enter-your-claim-form-container">
              <h2 className="form-step-title">File Motion with Your Case</h2>
              <div
                className="case-filing-checkbox-section"
                style={{ marginBottom: "20px" }}
              >
                <div className="case-filing-checkbox-container">
                  <input
                    type="checkbox"
                    id="filing-motion-checkbox"
                    className="case-filing-checkbox"
                    checked={isMotion}
                    onChange={async (e) => {
                      const newValue = e.target.checked;
                      setIsMotion(newValue);

                      // If unchecking, remove all saved motions
                      if (!newValue && motions.length > 0) {
                        // Remove all motions from server if they have IDs
                        for (const motion of motions) {
                          if (motion.id && motion.id > 0) {
                            await onRemoveMotion_Server(motion.id);
                          }
                        }
                        // Clear the motions array
                        setMotions([]);
                        setFlowError(""); // Clear any errors
                      }
                    }}
                  />
                  <label
                    htmlFor="filing-motion-checkbox"
                    className="case-filing-checkbox-label"
                  >
                    File motion(s)
                  </label>
                </div>
                <p>
                  Uncheck this box and click Proceed if you are not filing a
                  motion.
                </p>
              </div>
              {isMotion && (
                <div>
                  <form onSubmit={onSaveMotion}>
                    <div className="file-motion-form-fields">
                      <div className="select-group">
                        <label>Select Party </label>
                        <select
                          name="partyId"
                          value={motion.partyId}
                          required
                          onChange={onMotionChange}
                        >
                          <option value="">Select </option>
                          {partyOptions
                            ?.filter(
                              (opt) =>
                                (opt.partyTypeId == Constants.ClaimantType || opt.isLeadParty == true),
                            )
                            .map((opt, index) => (
                              <option key={index} value={opt.id}>
                                {opt.firstName} {opt.lastName ?? ""}
                              </option>
                            ))}
                        </select>
                      </div>
                      <div className="currency-container">
                        <div className="select-group">
                          <label> Motion/Application classification </label>
                          <select
                            name="motionClassificationId"
                            value={motion.motionClassificationId}
                            required
                            onChange={onMotionChange}
                          >
                            <option value="">Select </option>
                            {frequentData?.motionclass?.map((opt) => (
                              <option key={opt.id} value={opt.id}>
                                {opt.title}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className="select-group">
                          <label> Motion/Application Type </label>
                          <select
                            name="motionTypeId"
                            value={motion.motionTypeId}
                            required
                            onChange={onMotionChange}
                          >
                            <option value="">Select </option>
                            {frequentData?.motiontypes
                              ?.filter((e) => e.filingTypeId == 1)
                              .map((opt) => (
                                <option key={opt.id} value={opt.id}>
                                  {opt.title}
                                </option>
                              ))}
                          </select>
                        </div>
                      </div>
                      <div>
                        {motionPrayers?.map((pray, index) => (
                          <div
                            key={index}
                            className={`claim-item ${
                              removingIndex === index ? "removing" : ""
                            }`}
                          >
                            <div style={{ flex: 1 }}>
                              <div className="input-group">
                                <label>Particulars of Prayers Sought </label>
                                <div className="input-wrapper prayers-text-area-wrapper">
                                  <textarea
                                    placeholder=" Particulars of Prayers Sought"
                                    required={true}
                                    value={pray.prayer}
                                    onChange={(e) =>
                                      onChangePrayer(
                                        index,
                                        "prayer",
                                        e.target.value,
                                      )
                                    }
                                  />

                                  <div
                                    className="delete"
                                    onClick={() => onRemovePrayer(index)}
                                  >
                                    <DynamicIcon iname="trash-2" />{" "}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                        <button
                          className="add-claim-action-btn submit-button"
                          onClick={onAddPrayer}
                        >
                          Add Prayer
                        </button>
                      </div>
                    </div>

                    <button
                      className="add-claim-action-btn submit-button"
                      type="submit"
                    >
                      Save Motion
                    </button>
                  </form>
                </div>
              )}

              {/* <div className="flowbuttongroup">
              <JisButton onClick={on_motions_back}>Back</JisButton>
            </div> */}
            </div>
            {isMotion && motions.length > 0 && (
              <div
                className="parties-to-the-case-tabl"
                style={{ maxWidth: "100%", marginTop: "20px" }}
              >
                <div class="table-header">
                  <p>Motions</p>
                </div>
                <div className="table-wrappe">
                  <table
                    style={{ width: "100%", textAlign: "center" }}
                    className="case-detail"
                  >
                    <thead>
                      <tr>
                        <th>Party</th>
                        <th className="col-title">Application Classification</th>
                        <th className="col-medium">Application Type</th>
                        <th className="col-title">Prayers</th>
                        <th className="col-action">Edit</th>
                        <th className="col-action">Remove</th>
                      </tr>
                    </thead>
                    <tbody>
                      {motions?.map((opt, index) => (
                        <tr key={index}>
                          <td>
                            {
                              Constants.getItemById(partyOptions, opt.partyId)
                                ?.firstName
                            }{" "}
                            {Constants.getItemById(partyOptions, opt.partyId)
                              ?.lastName ?? ""}
                          </td>
                          <td>
                            {Constants.getItemById(
                              frequentData?.motionclass,
                              opt.motionClassificationId,
                            )?.title || "N/A"}
                          </td>
                          <td>
                            {Constants.getItemById(
                              frequentData?.motiontypes,
                              opt.motionTypeId,
                            )?.title || "N/A"}
                          </td>
                          <td>
                            <button
                              onClick={() => setPreviewPrayer(opt)}
                              className="selected"
                            >
                              View prayer
                            </button>
                            {/* <ol>
                              {(opt.motionPrayers || opt.prayers)?.map(
                                (pray, ind) => <li key={ind}>{pray.prayer}</li>
                              ) || "N/A"}
                            </ol> */}
                          </td>

                          <td>
                            <JisButton
                              variant="plain"
                              onClick={() => onEditMotion(opt, index)}
                            >
                              <svg
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M13.2603 3.59924L5.05034 12.2892C4.74034 12.6192 4.44034 13.2692 4.38034 13.7192L4.01034 16.9592C3.88034 18.1292 4.72034 18.9292 5.88034 18.7292L9.10034 18.1792C9.55034 18.0992 10.1803 17.7692 10.4903 17.4292L18.7003 8.73924C20.1203 7.23924 20.7603 5.52924 18.5503 3.43924C16.3503 1.36924 14.6803 2.09924 13.2603 3.59924Z"
                                  stroke="#292D32"
                                  strokeWidth="1.5"
                                  strokeMiterlimit={10}
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                                <path
                                  d="M11.8896 5.05078C12.3196 7.81078 14.5596 9.92078 17.3396 10.2008"
                                  stroke="#292D32"
                                  strokeWidth="1.5"
                                  strokeMiterlimit={10}
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                                <path
                                  d="M3 22H21"
                                  stroke="#292D32"
                                  strokeWidth="1.5"
                                  strokeMiterlimit={10}
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </JisButton>
                          </td>

                          <td>
                            <JisButton
                              variant="plain"
                              onClick={() => onRemoveMotion(index)}
                            >
                              <svg
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M21 5.98047C17.67 5.65047 14.32 5.48047 10.98 5.48047C9 5.48047 7.02 5.58047 5.04 5.78047L3 5.98047"
                                  stroke="#FF2E3B"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                                <path
                                  d="M8.5 4.97L8.72 3.66C8.88 2.71 9 2 10.69 2H13.31C15 2 15.13 2.75 15.28 3.67L15.5 4.97"
                                  stroke="#FF2E3B"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                                <path
                                  d="M18.8504 9.14062L18.2004 19.2106C18.0904 20.7806 18.0004 22.0006 15.2104 22.0006H8.79039C6.00039 22.0006 5.91039 20.7806 5.80039 19.2106L5.15039 9.14062"
                                  stroke="#FF2E3B"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                                <path
                                  d="M10.3301 16.5H13.6601"
                                  stroke="#FF2E3B"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                                <path
                                  d="M9.5 12.5H14.5"
                                  stroke="#FF2E3B"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </JisButton>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
            <div className="enter-your-claim-form-container">
              <div className="flowerror">{flowerror}</div>
              <button
                className="fill-btn-solid submit-button"
                type="submit"
                onClick={on_motions}
              >
                Proceed
              </button>
            </div>
          </div>
        )}
        {flow.code == "gazette" && (
          <div className="view">
            <Gazette
              filingtypeid={cinfo.caseFilingId}
              levelid={cinfo.caseCategoryId}
              feetypeid={FeeTYPEID}
              token={token}
              onProceed={(e) => onGazetteProceed(e)}
              caseid={cinfo.caseId}
              feeId={casefeeId}
            >
              <div className="top-nav">
                <div className="left-top">
                  <div className="top">
                    <h2 style={{ color: "var(--primary)" }}>
                      {cinfo?.referenceNumber} |{" "}
                      {
                        Constants.getItemById(
                          frequentData?.casecategories,
                          cinfo.caseCategoryId,
                        )?.categoryTitle
                      }
                    </h2>
                  </div>
                  <p>Select items related to the case that you are filing</p>
                </div>
                <p className="nav-status">Suit Filing /Specifications</p>
              </div>
            </Gazette>

            {/* <div className="flowbuttongroup">
              <JisButton onClick={on_gazette_back}>Back</JisButton>
              <JisButton type="submit" onClick={on_gazette}>
                Proceed
              </JisButton>
            </div> */}
          </div>
        )}
        {flow.code == "payment" && (
          <div className="view">
            <Payment feeid={casefeeId} token={token} />

            {/* <div className="flowbuttongroup">
              <JisButton onClick={on_payment_back}>Back</JisButton>
            </div> */}
          </div>
        )}
      </div>
      {showLegals && (
        <JisDialog>
          <div>List all available arthoney attached to the Firm</div>
        </JisDialog>
      )}

      {isSuccess && (
        <JisDialog title="Case Created Successfully.">
          <div>
            This case is created successfully. Payment is not required. Please
            continue to upload document
          </div>
          <JisButton onClick={onGotoDetails}>Upload document</JisButton>
        </JisDialog>
      )}

      {/* {showMotionDialog && (
        <JisDialog title="Motion Filing">
          <div style={{ marginBottom: "20px" }}>
            <p>Are you filing a motion in instituting this case?</p>
          </div>
          <div
            style={{ display: "flex", gap: "10px", justifyContent: "center" }}
          >
            <JisButton onClick={() => handleMotionDialogResponse(true)}>
              Yes
            </JisButton>
            <JisButton onClick={() => handleMotionDialogResponse(false)}>
              No
            </JisButton>
          </div>
        </JisDialog>
      )} */}

      <JisPrompt
        open={showMotionDialog}
        title="Motion Filing"
        onOk={() => handleMotionDialogResponse(true)}
        onCancel={() => handleMotionDialogResponse(false)}
      >
        <p>Are you filing a motion in instituting this case?</p>
      </JisPrompt>
      {isPreview && (
        <div className={"preview open"} style={{ overflow: "scroll" }}>
          <div className="heading">
            <div>
              <JisButton icon="close" onClick={() => setIsPreview(false)}>
                {" "}
                Close Preview
              </JisButton>
            </div>
          </div>
          <PdfViewer pdfUrl={fiatUrl} />

          <div className="date-btns"></div>
        </div>
      )}
      {previewPrayer && (
        <JisDialogForm
          title="Prayers"
          onClose={() => setPreviewPrayer(null)}
          minWidth="40%"
        >
          <div
            style={{
              maxWidth: "680px",
            }}
          >
            <ul style={{ gap: 10, display: "flex", flexDirection: "column" }}>
              {/* {motions.map((opt, ind) =>
               previewPrayer.motionPrayers?.map((pray, prayInd) => (
                  <li
                    style={{
                      fontWeight: "500",
                      fontSize: "16px",
                    }}
                    key={pray.id}
                  >
                    <span
                      style={{
                        marginRight: 8,
                      }}
                    >
                      {prayInd + 1}.
                    </span>
                    <span>{pray.prayer}</span>
                  </li>
                )),
              )} */}
              {previewPrayer.motionPrayers?.map((pray, prayInd) => (
                <li
                  style={{
                    fontWeight: "500",
                    fontSize: "16px",
                  }}
                  key={pray.id}
                >
                  <span
                    style={{
                      marginRight: 8,
                    }}
                  >
                    {prayInd + 1}.
                  </span>
                  <span>{pray.prayer}</span>
                </li>
              ))}
            </ul>
          </div>
        </JisDialogForm>
      )}

      <BackLoader open={loading} />
    </div>
  );
}

export default Filing_Case;
